var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "授权方",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入授权方名称" },
                                    model: {
                                      value: _vm.queryParam.keyword,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "keyword", $$v)
                                      },
                                      expression: "queryParam.keyword",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 12, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新增授权")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("a-table", {
                ref: "table",
                attrs: {
                  size: "middle",
                  bordered: "",
                  rowKey: "id",
                  columns: _vm.columns,
                  dataSource: _vm.dataSource,
                  pagination: false,
                  scroll: _vm.scroll,
                  loading: _vm.loading,
                },
                on: { change: _vm.handleTableChange },
                scopedSlots: _vm._u([
                  {
                    key: "apiKeySlot",
                    fn: function (text, record) {
                      return _c("span", {}, [
                        _c("span", [_vm._v(_vm._s(record.apiKey))]),
                        _c(
                          "a",
                          {
                            staticStyle: { "margin-left": "8px" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCopyKey(record.apiKey)
                              },
                            },
                          },
                          [_vm._v("复制")]
                        ),
                      ])
                    },
                  },
                  {
                    key: "statusSlot",
                    fn: function (text, record) {
                      return _c(
                        "span",
                        {},
                        [
                          record.status === 0
                            ? _c("a-tag", { attrs: { color: "green" } }, [
                                _vm._v("启用"),
                              ])
                            : _c("a-tag", { attrs: { color: "red" } }, [
                                _vm._v("已停用"),
                              ]),
                        ],
                        1
                      )
                    },
                  },
                  {
                    key: "action",
                    fn: function (text, record) {
                      return _c(
                        "span",
                        {},
                        [
                          _vm.btnEnableList.indexOf(4) > -1
                            ? _c(
                                "a-popconfirm",
                                {
                                  attrs: {
                                    title:
                                      record.status === 0
                                        ? "确定停用该授权吗？停用后三方调用将立即失效"
                                        : "确定启用该授权吗？",
                                  },
                                  on: {
                                    confirm: () =>
                                      _vm.handleToggleStatus(record),
                                  },
                                },
                                [
                                  _c("a", [
                                    _vm._v(
                                      _vm._s(
                                        record.status === 0 ? "停用" : "启用"
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.btnEnableList.indexOf(4) > -1 &&
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c("a-divider", { attrs: { type: "vertical" } })
                            : _vm._e(),
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a-popconfirm",
                                {
                                  attrs: { title: "确定删除吗？" },
                                  on: {
                                    confirm: () => _vm.handleDelete(record.id),
                                  },
                                },
                                [_c("a", [_vm._v("删除")])]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    },
                  },
                ]),
              }),
              _c("a-pagination", {
                staticStyle: { "margin-top": "16px", "text-align": "right" },
                attrs: {
                  size: "small",
                  "show-size-changer": "",
                  "show-quick-jumper": "",
                  current: _vm.ipagination.current,
                  "page-size": _vm.ipagination.pageSize,
                  "page-size-options": _vm.ipagination.pageSizeOptions,
                  total: _vm.ipagination.total,
                  "show-total": (total) => `共 ${total} 条`,
                },
                on: {
                  change: _vm.paginationChange,
                  showSizeChange: _vm.paginationShowSizeChange,
                },
                scopedSlots: _vm._u([
                  {
                    key: "buildOptionText",
                    fn: function (props) {
                      return [
                        _c("span", [_vm._v(_vm._s(props.value) + "条/页")]),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: "新增授权",
                    visible: _vm.addVisible,
                    confirmLoading: _vm.confirmLoading,
                    maskClosable: false,
                    okText: "保存",
                    cancelText: "取消",
                  },
                  on: {
                    ok: _vm.handleAddOk,
                    cancel: function ($event) {
                      _vm.addVisible = false
                    },
                  },
                },
                [
                  _c(
                    "a-form",
                    {
                      attrs: {
                        labelCol: { span: 5 },
                        wrapperCol: { span: 17 },
                      },
                    },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "授权方名称", required: "" } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "请输入授权方名称，如：××小程序",
                              maxLength: 50,
                            },
                            model: {
                              value: _vm.addForm.authName,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "authName", $$v)
                              },
                              expression: "addForm.authName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "备注" } },
                        [
                          _c("a-textarea", {
                            attrs: {
                              placeholder: "请输入备注",
                              rows: 3,
                              maxLength: 200,
                            },
                            model: {
                              value: _vm.addForm.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "remark", $$v)
                              },
                              expression: "addForm.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: "授权key已生成",
                    visible: _vm.keyVisible,
                    closable: false,
                    maskClosable: false,
                    okText: "我已复制保存",
                    cancelButtonProps: { style: { display: "none" } },
                  },
                  on: {
                    ok: function ($event) {
                      _vm.keyVisible = false
                    },
                  },
                },
                [
                  _c("a-alert", {
                    staticStyle: { "margin-bottom": "16px" },
                    attrs: {
                      type: "warning",
                      showIcon: "",
                      message: "请立即复制保存，关闭后仍可在列表中查看",
                    },
                  }),
                  _c(
                    "a-form",
                    {
                      attrs: {
                        labelCol: { span: 5 },
                        wrapperCol: { span: 17 },
                      },
                    },
                    [
                      _c("a-form-item", { attrs: { label: "授权方" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.generatedKey.authName))]),
                      ]),
                      _c("a-form-item", { attrs: { label: "API Key" } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-family": "monospace",
                              "word-break": "break-all",
                            },
                          },
                          [_vm._v(_vm._s(_vm.generatedKey.apiKey))]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", icon: "copy" },
                      on: {
                        click: function ($event) {
                          return _vm.handleCopyKey(_vm.generatedKey.apiKey)
                        },
                      },
                    },
                    [_vm._v("复制key")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }